/**
 * Agent QA API - API calls for agent Q&A cache management
 */
import axiosClient from "./axiosClient";

const agentQaApi = {
  /**
   * Get all Q&A entries
   */
  getAll: (accountId) => {
    const params = {};
    if (accountId) params.accountId = accountId;
    return axiosClient.get("/agent-qa", { params });
  },

  /**
   * Create new Q&A entry
   */
  create: (data) => {
    return axiosClient.post("/agent-qa", data);
  },

  /**
   * Update Q&A entry
   */
  update: (id, data) => {
    return axiosClient.put(`/agent-qa/${id}`, data);
  },

  /**
   * Delete Q&A entry
   */
  delete: (id) => {
    return axiosClient.delete(`/agent-qa/${id}`);
  },

  /**
   * Search Q&A by semantic similarity
   */
  search: (question, accountId, threshold) => {
    return axiosClient.post("/agent-qa/search", {
      question,
      accountId,
      threshold,
    });
  },

  /**
   * Bulk update shops
   */
  bulkUpdateShops: (ids, shopIds) => {
    return axiosClient.post("/agent-qa/bulk-update-shops", {
      ids,
      shopIds,
    });
  },
};

export default agentQaApi;
